import React, { FunctionComponent } from "react"
import Img from "gatsby-image"

interface IHeaderProps {
  data: any
}

const Header: FunctionComponent<IHeaderProps> = ({ data }) => {
  return (
    <div className="flex items-center justify-center container my-10 md:flex-row flex-col">
      <div className="p-4">
        <Img
          className="rounded-full shadow-2xl hover:shadow-lg transition duration-300"
          fixed={data.fileName.childImageSharp.fixed}
          alt="Dragos Nedelcu avatar"
        />
      </div>
      <h1 className="text-primary-700 text-3xl font-bold my-4">
        Hi! I'm Dragos Nedelcu and I build web applications.
      </h1>
    </div>
  )
}

export default Header
